import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.72624 11.6507C3.87192 12.6948 5.3629 13.2817 6.91472 13.2994C8.46654 13.3171 9.97057 12.7643 11.1399 11.7465C12.3091 10.7287 13.0618 9.3172 13.2543 7.78123C13.4468 6.24525 13.0656 4.69235 12.1835 3.41881C11.3014 2.14526 9.98004 1.24022 8.47161 0.876347C6.96317 0.512479 5.37323 0.715257 4.00512 1.44599C2.63701 2.17673 1.5865 3.38428 1.05403 4.83824M0.703125 1.33824V4.83824H4.21215" />
  </svg>
);
